// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"671":"1a11cfc5","912":"e4cd583e"}[chunkId] + ".css";
};